import * as React from "react";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/Modules/Core/Components/shadcn/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/Modules/Core/Components/shadcn/popover";
import { Calendar } from "@/Modules/Core/Components/shadcn/calendar";

export type DatePickerProps = {
  value?: Date;
  onChange?: (date?: Date) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
};

export function DatePicker({
  value,
  onChange,
  placeholder = "Pick a date",
  disabled,
  className,
}: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          className={cn(
            "h-9 w-full justify-start gap-2.5 text-left text-[13px] font-normal [&_svg]:m-0 [&_svg]:p-0",
            !value && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="h-4 w-4 shrink-0 opacity-70" />
          {value ? format(value, "MMM dd, yyyy") : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value}
          onSelect={(d) => onChange?.(d)}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
